import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { requireAuth } from '@xemplo/auth-provider';
import { ErrorBoundary } from '@xemplo/error-boundary';
import { PayrollRoutes } from '@xemplo/gp-routes';
import { withLazyComponent } from '@xemplo/lazy-component';

const PayScheduleScreen = lazy(() =>
  import('@xemplo/gp-pay-schedule-pay-schedule-screen').then((m) => ({
    default: m.GpPaySchedulePayScheduleScreen,
  })),
);

const PayScheduleDetailsScreen = lazy(() =>
  import('@xemplo/gp-pay-schedule-details-screen').then((m) => ({
    default: m.GpPayScheduleDetailsScreen,
  })),
);

const DetailsTab = lazy(() =>
  import('@xemplo/gp-pay-schedule-details-details-page').then((m) => ({
    default: m.GpPayScheduleDetailsDetailsPage,
  })),
);

const FeesTab = lazy(() =>
  import('@xemplo/gp-pay-schedule-details-fees-page').then((m) => ({
    default: m.GpPayScheduleDetailsFeesPage,
  })),
);

export const PayScheduleRouteWithTemplate: RouteObject[] = [
  {
    path: PayrollRoutes.PayScheduleScreen,
    Component: requireAuth(withLazyComponent(PayScheduleScreen)),
    errorElement: <ErrorBoundary />,
  },
];

export const PayScheduleRoutesFullScreen: RouteObject[] = [
  {
    path: PayrollRoutes.PayScheduleDetails,
    Component: requireAuth(withLazyComponent(PayScheduleDetailsScreen)),
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        Component: DetailsTab,
      },
      {
        path: PayrollRoutes.PayScheduleDetailsFees,
        Component: FeesTab,
      },
    ],
  },
];
